export const totalEmails = [
    { month: 'Jan', sent: 2000, bounced: 600 },
    { month: 'Feb', sent: 6000, bounced: 1800 },
    { month: 'Mar', sent: 1000, bounced: 100 },
    { month: 'Apr', sent: 5000, bounced: 2800 },
    { month: 'May', sent: 3000, bounced: 1200 },
    { month: 'Jun', sent: 6000, bounced: 3000 },
    { month: 'Jul', sent: 1000, bounced: 20 },
];
